<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon"
                      @click.stop="showSidebar"/>

        <div style="display: flex; align-items: center" v-if="$acl.check('admin')">
          <router-link to="/warehouse/products?brand=2">
            <img style="height: 25px; margin-right: 1rem"
                 src="https://firebasestorage.googleapis.com/v0/b/kardi-48465.appspot.com/o/content%2Fchangan.jpeg?alt=media&token=b46e0549-620a-48e3-87c9-53c71c7b6f7e">
          </router-link>
          <router-link to="/warehouse/products?brand=12">
            <img style="height: 50px; margin-right: 1rem"
                 src="https://kardi-br.s3.sa-east-1.amazonaws.com/brands/1pbQHhFfXHRqHkT6iGYFHdQkUrgCyskv70larYAK.jpeg">
          </router-link>
          <router-link to="/warehouse/products?brand=22">
            <img style="height: 50px; margin-right: 1rem"
                 src="https://kardi-br.s3.sa-east-1.amazonaws.com/brands/zMv1yjsLaDXMC2QuNgAEgZKViyxLHnuYWTHruBpT.jpeg">
          </router-link>
          <router-link to="/warehouse/products?brand=32">
            <img style="height: 50px; margin-right: 1rem"
                 src="https://kardi-br.s3.sa-east-1.amazonaws.com/brands/pWTvK5MDACj2W2Tl1lpgPeg5nwQdZhG47dDyfmLm.jpeg">
          </router-link>
          <router-link to="/warehouse/products?brand=42">
            <img style="height: 50px; margin-right: 1rem"
                 src="https://firebasestorage.googleapis.com/v0/b/kardi-48465.appspot.com/o/content%2Fderco-maq.jpeg?alt=media&token=b3755713-65aa-4867-b5a0-3d8c1ecaf91a">
          </router-link>
          <router-link to="/warehouse/products?brand=52">
            <img style="height: 50px; margin-right: 1rem"
                 src="https://kardi-br.s3.sa-east-1.amazonaws.com/brands/wAZ0pc56JZPp5xrwrINkDwDp1hjlLjagmjXVM5s0.jpeg">
          </router-link>
          <router-link to="/warehouse/products?brand=62">
            <img style="height: 50px; margin-right: 1rem"
                 src="https://kardi-br.s3.sa-east-1.amazonaws.com/brands/wDdP1cfp3REh4bezDVa3qZ0jpMc15TAHcfzUoT98.jpeg">
          </router-link>
          <router-link to="/warehouse/products?brand=72">
            <img style="height: 50px; margin-right: 1rem"
                 src="https://kardi-br.s3.sa-east-1.amazonaws.com/brands/GYznVVyCpVm0yJvWszoCbGBtdJUmijp1lmtlWMER.jpeg">
          </router-link>
          <router-link to="/warehouse/products?brand=82">
            <img style="height: 50px; margin-right: 1rem"
                 src="https://kardi-br.s3.sa-east-1.amazonaws.com/brands/HvDotzk6wXBMMX2XSxbaDHtBOWrTFAueJvm7YkHI.jpeg">
          </router-link>
          <router-link to="/warehouse/products?brand=92">
            <img style="height: 50px; margin-right: 1rem"
                 src="https://kardi-br.s3.sa-east-1.amazonaws.com/brands/FVU2javlcRuinGEQoVSUcFUSZBH5mXIGao1HAmni.jpeg">
          </router-link>
          <router-link to="/warehouse/products?brand=102">
            <img style="height: 50px; margin-right: 1rem"
                 src="https://kardi-br.s3.sa-east-1.amazonaws.com/brands/HH7cAWfEscrheTCZWUXEmvDEpjDx1G62iiRG3XDT.jpeg">
          </router-link>
          <router-link to="/warehouse/products?brand=112">
            <img style="height: 50px; margin-right: 1rem"
                 src="https://kardi-br.s3.sa-east-1.amazonaws.com/brands/WkzAtkhL6L9WU0a1W5CB7OrkfUe3QiFS4VD2quPn.jpeg">
          </router-link>
          <router-link to="/warehouse/products?brand=122">
            <img style="height: 50px; margin-right: 1rem"
                 src="https://kardi-br.s3.sa-east-1.amazonaws.com/brands/S2v713m3Zhdsn66dOHdOU9mkIdM1I9YxttYJDUkT.jpeg">
          </router-link>
        </div>
        <div v-else>
          <router-link v-for="(b, index ) in brands" :key="index" :to="`/warehouse/products?brand=${b.id}`">
            <img style="height: 50px; margin-right: 1rem"
                 :src="b.image">
          </router-link>
        </div>

        <vs-spacer/>

        <profile-drop-down/>

      </vs-navbar>
    </div>
  </div>
</template>


<script>
import ProfileDropDown from './components/ProfileDropDown.vue'

const firebase = require('firebase/app')
// Required for side-effects
require('firebase/firestore')
let db = firebase.firestore()
export default {
  name: 'the-navbar-vertical',
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  data () {
    return {
      brands: []
    }
  },
  components: {
    ProfileDropDown
  },
  async created () {
    if (!this.$acl.check('admin')) {
      const querySnapUsers = await db.collection('users').where('uid', '==', firebase.auth().currentUser.uid).get()
      let user = {}
      querySnapUsers.forEach((doc) => {
        user = {
          id: doc.id,
          ...doc.data()
        }
      })
      const clientDoc = await db.collection('clients').doc(user.client.id).get()
      this.brands = [...clientDoc.data().brand]
    }
  },
  computed: {
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return { 'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark') }
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else return 'navbar-full'
    }
  },
  methods: {
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    }
  }
}
</script>

